export default "__VITE_ASSET__CwxR3Vt9__"